import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function PromoBanner() {
  return (
    <section className="dyntra-container mt-10">
      <div className="relative overflow-hidden rounded-2xl" style={{ background: "linear-gradient(120deg, #361D82 0%, #4B2AAD 55%, #6B4CD9 100%)" }}>
        <div className="absolute inset-y-0 right-0 w-1/2 hidden md:block">
          <img
            src="https://images.pexels.com/photos/5215024/pexels-photo-5215024.jpeg?auto=compress&cs=tinysrgb&w=900&h=500"
            alt=""
            className="h-full w-full object-cover object-center opacity-40 mix-blend-luminosity"
          />
          <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, #4B2AAD 0%, transparent 100%)" }} />
        </div>
        <div className="relative px-8 sm:px-12 py-10 md:py-12 max-w-2xl">
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-white">Become a Dyntra Partner</h2>
          <p className="text-white/85 text-base mt-2 max-w-lg">Grow your business with India's most trusted dental ecommerce platform.</p>
          <div className="mt-5 flex flex-col gap-4">
            <Link
              data-testid="promo-join-btn"
              to="/partner"
              className="self-start inline-flex items-center gap-2 rounded-xl bg-white text-[#4B2AAD] px-5 py-2.5 text-sm font-bold hover:bg-white/90 transition-colors shadow-lg"
            >
              Join Now
            </Link>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-2 max-w-2xl">
              {[
                "Exclusive Benefits",
                "Marketing Support",
                "Higher Visibility",
                "Dedicated Support",
              ].map((tag) => (
                <div key={tag} className="flex items-center gap-2 text-white/90 text-xs">
                  <CheckCircle2 className="h-4 w-4 text-[#FFB020] shrink-0" />
                  <span>{tag}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
